import { AxiosInstance } from "axios";
import { NewPasswordInput, UpdatePasswordInput } from "@/types/passwordReset";

export interface PasswordRestRepository {
  passwordReset(data: UpdatePasswordInput): Promise<void>;
  passwordResetConfirm(data: NewPasswordInput): Promise<void>;
}

class PasswordResetRepositoryImpl implements PasswordRestRepository {
  private readonly client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async passwordResetConfirm(data: NewPasswordInput): Promise<void> {
    await this.client
      .post<NewPasswordInput>(`/api/v1/auth/password`, data)
      .catch((error) => {
        if (error.response.status === 409) {
          throw new Error("内容が重複しております");
        } else {
          throw new Error(error.response.message);
        }
      });
  }

  async passwordReset(data: UpdatePasswordInput): Promise<void> {
    await this.client
      .put<UpdatePasswordInput>(`/api/v1/auth/password`, data)
      .catch((error) => {
        if (error.response.status === 409) {
          throw new Error("内容が重複しております");
        } else {
          throw new Error(error.response.message);
        }
      });
  }
}

export function newPasswordResetRepository(
  client: AxiosInstance
): PasswordRestRepository {
  return new PasswordResetRepositoryImpl(client);
}
